import { MilestoneTypes } from './actionTypes';

export const getMilestones = (milestonesAdd: any) => {
    return {
        type: MilestoneTypes.GET_MILESTONES,
        payload: { milestonesAdd },
    };
};

export const getMilestonesSuccess = (clients: any) => ({
    type: MilestoneTypes.GET_MILESTONES_SUCCESS,
    payload: clients,
});

export const getMilestonesFail = (error: any) => ({
    type: MilestoneTypes.GET_MILESTONES_FAIL,
    payload: error,
});

export const getMilestonesDetail = (clientId: number) => ({
    type: MilestoneTypes.GET_MILESTONES_DETAIL,
    clientId,
});

export const getMilestonesDetailSuccess = (clients: any) => ({
    type: MilestoneTypes.GET_MILESTONES_DETAIL_SUCCESS,
    payload: clients,
});

export const getMilestonesDetailFail = (error: any) => ({
    type: MilestoneTypes.GET_MILESTONES_DETAIL_FAIL,
    payload: error,
});

export const addMilestones = (milestonesAdd: any) => {
    return {
        type: MilestoneTypes.ADD_MILESTONES,
        payload: { milestonesAdd },
    };
};

export const addMilestonesSuccess = (milestonesAdd: any) => {
    return {
        type: MilestoneTypes.ADD_MILESTONES_SUCCESS,
        payload: milestonesAdd,
    };
};

export const addMilestonesFail = (error: any) => {
    return {
        type: MilestoneTypes.ADD_MILESTONES_FAIL,
        payload: error,
    };
};

export const deleteMilestones = (id: any) => {
    return {
        type: MilestoneTypes.DELETE_MILESTONES,
        payload: { id },
    };
};

export const deleteMilestonesSuccess = (payload: any) => {
    return {
        type: MilestoneTypes.DELETE_MILESTONES_SUCCESS,
        payload,
    };
};

export const deleteMilestonesFail = (error: any) => {
    return {
        type: MilestoneTypes.DELETE_MILESTONES_FAIL,
        payload: error,
    };
};

export const updateMilestones = (data: any) => {
    return {
        type: MilestoneTypes.UPDATE_MILESTONES,
        payload: { data },
    };
};

export const updateMilestonesSuccess = (data: any) => {
    return {
        type: MilestoneTypes.UPDATE_MILESTONES_SUCCESS,
        payload: data,
    };
};

export const updateMilestonesFail = (error: any) => {
    return {
        type: MilestoneTypes.UPDATE_MILESTONES_FAIL,
        payload: error,
    };
};

export const getMilestonOperationData = (Operation: any) => {
    return {
        type: MilestoneTypes.GET_MILESTONES_OPERATION_DATA,
        payload: { Operation },
    };
};

export const getMilestonOperationDataSuccess = (clients: any) => ({
    type: MilestoneTypes.GET_MILESTONES_OPERATION_DATA_SUCCESS,
    payload: clients,
});

export const getMilestonOperationDataFail = (error: any) => ({
    type: MilestoneTypes.GET_MILESTONES_OPERATION_DATA_FAIL,
    payload: error,
});


export const getMilestonesLifeEvents = () => {
    return {
        type: MilestoneTypes.GET_MILESTONES_LIFE_EVENTS_DATA
    };
};

export const getMilestonesLifeEventsSuccess = (data: any) => ({
    type: MilestoneTypes.GET_MILESTONES_LIFE_EVENTS_DATA_SUCCESS,
    payload: data,
});

export const getMilestonesLifeEventsFail = (error: any) => ({
    type: MilestoneTypes.GET_MILESTONES_LIFE_EVENTS_DATA_FAIL,
    payload: error,
});

export const addMilestonesLifeEvents = (data: any) => {
    return {
        type: MilestoneTypes.ADD_MILESTONES_LIFE_EVENTS,
        payload: data,
    };
};

export const addMilestonesLifeEventsSuccess = (data: any) => {
    return {
        type: MilestoneTypes.ADD_MILESTONES_LIFE_EVENTS_SUCCESS,
        payload: data,
    };
};

export const addMilestonesLifeEventsFail = (error: any) => {
    return {
        type: MilestoneTypes.ADD_MILESTONES_LIFE_EVENTS_FAIL,
        payload: error,
    };
};